
export default function Prompt () {
    return async function (params) {
        const { question } = params
        if(typeof(window) !== 'undefined') {
            return window.prompt(question, '')
        }
        return ''
    }
}